import React from 'react';
import { Link } from 'gatsby';

import Logo from './ui/logo';
import SocialIcons from './ui/social-icons';
import { useSiteMetadata } from '../hooks/use-site-metadata';
import { Separator } from './ui/separator';
import { navigationMenuTriggerStyle } from './ui/navigation-menu';

const Footer = () => {
  const { title, footerLinks } = useSiteMetadata();
  return (
    <section className='mt-10'>
      <div className='max-w-screen-xl px-2 pt-12 mx-auto space-y-8 overflow-hidden sm:px-6 lg:px-8 flex items-center flex-col mt-auto'>
        <Logo isHeader={false} />
        <nav className='flex flex-wrap justify-center -mx-5 -my-2'>
          {footerLinks.map((navLink, i) => {
            return (
              <div className='md:px-1 lg:px-2 xl:px-4 py-2' key={navLink.name}>
                <Link
                  to={navLink.path}
                  className={navigationMenuTriggerStyle()}
                  activeClassName='text-accent-foreground bg-accent/50'
                >
                  {navLink.name}
                </Link>
              </div>
            );
          })}
        </nav>
        <p>
          JSDev Space – Your go-to hub for JavaScript development. Explore expert guides, best practices, and the latest trends in web development, React, Node.js, and more. Stay ahead with cutting-edge tutorials, tools, and insights for modern JS developers. 🚀
        </p>
        <p>
          Join our growing community of developers! Follow us on social media for updates, coding tips, and exclusive content. Stay connected and level up your JavaScript skills with us! 🔥
        </p>
        <Separator className='my-6' />
        <SocialIcons isFooter={true} styleClass='mt-8 space-x-6' />
        <p className='mt-8 text-base leading-6 text-center text-gray-400'>
          &copy; {new Date().getFullYear()} {title}. All rights reserved.
        </p>
      </div>
    </section>
  );
};
export default Footer;
